import { ElMessageBox } from 'element-plus'
import { Storage } from './storage'

let authPrompting = false
let authPromptedAt = 0
const AUTH_PROMPT_COOLDOWN_MS = 1500

export async function promptLoginOnce() {
  if (typeof window === 'undefined') return
  const now = Date.now()
  if (authPrompting) return
  if (now - authPromptedAt < AUTH_PROMPT_COOLDOWN_MS) return
  authPrompting = true
  authPromptedAt = now

  const redirect = `${window.location.pathname}${window.location.search}${window.location.hash}`
  try {
    await ElMessageBox.confirm('该操作需要登录后继续', '请先登录', {
      type: 'warning',
      confirmButtonText: '去登录',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      closeOnPressEscape: true
    })
    if (String(window.location.pathname || '') === '/login') return
    window.location.href = `/login${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`
  } catch {
  } finally {
    authPrompting = false
  }
}

export async function handleAuthExpired() {
  Storage.clearToken()
  await promptLoginOnce()
}
